import { createClient } from '@/shared/api';
import type { DeleteStudiesMutation, DeleteStudiesMutationVariables } from '@/shared/api';
import DELETE_STUDIES_MUTATION from '../mutations/deleteStudies';

/**
 * Deletes the studies named by the supplied identifiers. Runs DELETE_STUDIES_MUTATION and throws deleteStudies.message when isSuccess is false.
 *
 * @param studyIds - Identifiers of the studies to delete.
 * @returns A promise resolving once the mutation result has been checked for success.
 */
const handleDeleteStudies = async (studyIds: any) => {
  const client = createClient();
  const deleteStudiesResult = await client.mutate<
    DeleteStudiesMutation,
    DeleteStudiesMutationVariables
  >({
    mutation: DELETE_STUDIES_MUTATION,
    variables: {
      studyIds,
    },
  });
  const { data } = deleteStudiesResult;
  // client.mutate's default errorPolicy throws before this line on any GraphQL error, so data is always present here.
  const { deleteStudies } = data!;
  if (!deleteStudies!.isSuccess) {
    throw new Error(deleteStudies!.message ?? undefined);
  }
};

export default handleDeleteStudies;
